<template>
	<div>
		<div style="display: flex;justify-content: center;align-items: center;height: 100vh;font-size: 0.6rem;flex-direction: column;">
			<p>感谢您的参与！</p>
			<div class="save-children" @click="fanhui()" style="margin-top: 10vh;">点击返回</div>
		</div>
	</div>
</template>

<script>
export default {
  name: 'thank',
  data () {
    return {
    }
  },
  created:function(){
  },
  methods:{
  	fanhui:function(){
  		this.$router.push({name:'scalarlist'})
  	},
  }
}
</script>

<style scoped>
	.save-children{
	    width: 6rem;
	    height: 1rem;
	    line-height: 1rem;
	    background: #26a2ff;
	    color: #fff;
	    text-align: center;
	    font-size: 0.5rem;
	    border-radius: 0.50rem;
	    margin: 0.30rem auto;
	}
</style>


// WEBPACK FOOTER //
// src/pages/thank.vue